export default __webpack_public_path__ + "static/media/juggernaut-round-icon.24cb26be.svg";